import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import { Copy, Check } from "lucide-react";
// @ts-ignore — raw import via asset/source loader
import readmeContent from "../../README.md";
// @ts-ignore — raw import via asset/source loader
import agentContent from "../../AGENTS.md";

type Tab = "readme" | "agent";

export function HowTo() {
  const [tab, setTab] = useState<Tab>("readme");
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    navigator.clipboard.writeText(agentContent).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.heading}>How To</h1>

        <div style={styles.tabBar}>
          <div style={styles.tabs}>
            <button
              style={{ ...styles.tab, ...(tab === "readme" ? styles.tabActive : {}) }}
              onClick={() => setTab("readme")}
            >
              README
            </button>
            <button
              style={{ ...styles.tab, ...(tab === "agent" ? styles.tabActive : {}) }}
              onClick={() => setTab("agent")}
            >
              Agent Instructions
            </button>
          </div>
          {tab === "agent" && (
            <button style={{ ...styles.copyBtn, ...(copied ? styles.copyBtnDone : {}) }} onClick={handleCopy}>
              {copied ? <Check size={14} /> : <Copy size={14} />}
              {copied ? "Copied!" : "Copy"}
            </button>
          )}
        </div>

        <div style={styles.content}>
          <ReactMarkdown>{tab === "readme" ? readmeContent : agentContent}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: {
    flex: 1,
    overflowY: "auto",
    background: "#f8f9fa",
    padding: "2rem",
  },
  container: {
    maxWidth: 820,
    margin: "0 auto",
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    padding: "2rem 2.5rem",
  },
  heading: {
    fontSize: "1.5rem",
    fontWeight: 700,
    marginBottom: "1.25rem",
    color: "#202124",
  },
  tabBar: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    borderBottom: "2px solid #e0e0e0",
    marginBottom: "1.5rem",
  },
  tabs: {
    display: "flex",
    gap: 0,
  },
  tab: {
    background: "none",
    border: "none",
    borderBottom: "2px solid transparent",
    marginBottom: -2,
    padding: "0.5rem 1.25rem",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: 500,
    color: "#666",
  },
  tabActive: {
    borderBottomColor: "#136945",
    color: "#136945",
  },
  copyBtn: {
    display: "flex", alignItems: "center", gap: 5,
    marginBottom: 4,
    background: "none", border: "1px solid #ccc", borderRadius: 6,
    padding: "4px 12px", cursor: "pointer", fontSize: "0.8rem", color: "#555",
  },
  copyBtnDone: {
    borderColor: "#16a34a", color: "#16a34a",
  },
  content: {
    fontSize: "0.9rem",
    lineHeight: 1.7,
    color: "#333",
  },
};
